export default __webpack_public_path__ + "img/main.discover-placeholder@2x.61827539.png";